import React, {useState} from "react";
import {TextField} from "@mui/material";
import {normalizeSmallUnits} from "../../../../misc/DimFormat";
import {useProjectUnitSystem} from "../ProjectName";

// A glass dimension typed in the project's units. On blur the value is rewritten in the
// project's small unit; a value in the other system's units is left as typed and flagged.
export function GlassDimensionInput(props: {
    label: string;
    value: string;
    allowZero?: boolean;
    onChange(value: string): void;
}) {
    const sys = useProjectUnitSystem() || "imperial";
    const [error, setError] = useState("");

    return (
        <TextField fullWidth size="small" label={props.label} value={props.value}
                   error={!!error} helperText={error || undefined}
                   onChange={e => {
                       setError("");
                       props.onChange(e.target.value);
                   }}
                   onBlur={() => {
                       if(props.value.trim() === "") return;

                       try {
                           props.onChange(normalizeSmallUnits(props.value, sys, {allowZero: props.allowZero}));
                       } catch (e: any) {
                           setError(e.message);
                       }
                   }} />
    )
}
